import { type CreateBlockData } from '@/lib/builder/types'

import {
  type IntegrationsSection,
  type IntegrationsSectionCreate,
} from '../../../WebsiteBuilder.types'

export const createIntegrationsData = ({
  brandId,
}: CreateBlockData<IntegrationsSection>): IntegrationsSectionCreate => ({
  brandId,
  params: {
    locationId: null,
    providerType: 'untappd',
    themeId: null,
  },
  type: 'integrations',
})
